import React from "react";
import styled from "styled-components";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const ContainerWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 1024px) {
    padding: 0 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 0 1rem;
  }

  @media (max-width: 480px) {
    padding: 0 0.8rem;
  }
`;

const Container: React.FC<ContainerProps> = ({ children, className }) => {
  return <ContainerWrapper className={className}>{children}</ContainerWrapper>;
};

export default Container;
